import { Model, ModelAttributes, model, modelConfig } from "@mixitone/oom";
import { setAccountId } from "./concerns/SetAccountId";
import { Database } from "./database.types";

const config = modelConfig(
  {
    accepted_at: {
      type: "datetime",
    },
    account_id: {
      type: "string",
    },
    club_document_id: {
      type: "string",
    },
    club_player_id: {
      type: "string",
    },
    created_at: {
      type: "datetime",
    },
    document_name: {
      type: "string",
    },
    is_deleted: {
      type: "boolean",
    },
    recorded_by_user_id: {
      type: "string",
    },
    series_id: {
      type: "string",
    },
    source: {
      type: "enum",
      enumType: "self" as Database["public"]["Enums"]["club_document_acceptance_source"],
    },
    updated_at: {
      type: "datetime",
    },
    version: {
      type: "number",
    },
  },
  {
    // Add collections here if needed
  },
  {
    // Add references here if needed
  },
);

interface ClubPlayerAcceptedDocument extends ModelAttributes<typeof config> {}

@setAccountId
@model("club_player_accepted_documents", config)
class ClubPlayerAcceptedDocument extends Model<typeof config> {}

export default ClubPlayerAcceptedDocument;
